//
// ButtonType.js
// commons
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */

var ButtonType = {
    DOT:0,
    LINK:1,
    BUTTON:2,
    TAB:3,
    PROGRESSNUMBER:4,
    THUMBNAIL:5
};
export default ButtonType;
